const getThnksCompanyId = () => global.IS_LOCAL_OR_DEV ? '39' : '349';

export { getThnksCompanyId };
